import { AutogenLayoutCarrierSalesProfileFilter } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierSalesProfileFilter";
import { CarrierSalesProfile } from "./CarrierSalesProfile";

export class CarrierSalesProfileFilter extends AutogenLayoutCarrierSalesProfileFilter {

    override onLoad() {
        const profileLayout = this.layoutProfile as CarrierSalesProfile;
        profileLayout.textboxDescr.required = false;
    }

}